import { getStorageAccess, getStorageUpload } from '@/generated/api-client'
import { configureOpenApiClient } from '@/lib/api/client/configure-openapi-client'

configureOpenApiClient()

function resolveApiBaseURL(): string {
    if (process.env.NEXT_PUBLIC_API_URL) {
        return process.env.NEXT_PUBLIC_API_URL
    }
    if (typeof window !== 'undefined') {
        return '/api'
    }
    const appBase = process.env.NEXT_PUBLIC_APP_BASE_URL || 'http://localhost:3000'
    return `${appBase.replace(/\/$/, '')}/api`
}

/** Mint a short-lived signed read URL for an existing storage object. */
export async function fetchStorageAccessUrl(fileUrl: string): Promise<string> {
    const { data } = await getStorageAccess({
        query: { fileUrl },
        baseURL: resolveApiBaseURL(),
        throwOnError: true,
    })
    return data.url
}

export type StorageUploadCredentialInput = {
    containerName: string
    blobName: string
    contentType?: string
}

export type StorageUploadCredential = {
    uploadUrl: string
    fileUrl: string
}

/** Mint signed upload credentials (`uploadUrl` + canonical `fileUrl`). */
export async function fetchStorageUploadCredential(input: StorageUploadCredentialInput): Promise<StorageUploadCredential> {
    const { data } = await getStorageUpload({
        query: {
            containerName: input.containerName,
            blobName: input.blobName,
            contentType: input.contentType,
        },
        baseURL: resolveApiBaseURL(),
        throwOnError: true,
    })
    return {
        uploadUrl: data.uploadUrl,
        fileUrl: data.fileUrl,
    }
}
